import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";
import EmailIcon from "@mui/icons-material/Email";

interface ShareStoreDialogProps {
  open: boolean;
  onClose: () => void;
  storeUrl: string;
  storeName: string;
}

const ShareStoreDialog: React.FC<ShareStoreDialogProps> = ({ open, onClose, storeUrl, storeName }) => {
  const [copied, setCopied] = useState(false);
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(storeUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      /* fallback */
    }
  };

  const handleClose = () => {
    setCopied(false);
    onClose();
  };

  const handleEmail = () => {
    const subject = encodeURIComponent(`Check out ${storeName}`);
    const body = encodeURIComponent(`Visit our store here: ${storeUrl}`);
    window.location.href = `mailto:?subject=${subject}&body=${body}`;
  };


  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth disableScrollLock PaperProps={{ sx: { borderRadius: "12px" } }}>
      <div className="share-dialog-header">
        <span className="share-dialog-title">Share Store</span>
        <IconButton onClick={handleClose} size="small" className="share-dialog-close">
          <CloseIcon fontSize="small" />
        </IconButton>
      </div>

      <DialogContent sx={{ padding: "16px 24px 24px" }}>
          <div className="share-dialog-options">
            <button className="share-dialog-btn" onClick={() => window.open(storeUrl, "_blank")}>
              <OpenInNewIcon fontSize="small" />
              <span>Open Store</span>
            </button>
            <button className="share-dialog-btn" onClick={handleCopy}>
              {copied ? <CheckIcon fontSize="small" style={{ color: "#2e7d32" }} /> : <ContentCopyIcon fontSize="small" />}
              <span>{copied ? "Copied!" : "Copy Link"}</span>
            </button>
            <button className="share-dialog-btn" onClick={handleEmail}>  {/* ➕ NEW */}
              <EmailIcon fontSize="small" />
              <span>Share via Email</span>
            </button>
          </div>
      </DialogContent>
    </Dialog>
  );
};

export default ShareStoreDialog;